<section
  id="main-content">
           <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</section>